import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-contact-help',
  templateUrl: './contact-help.component.html',
  styleUrls: ['./contact-help.component.scss']
})
export class ContactHelpComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
